module.exports = __webpack_public_path__ + "img/puzzle_28.2613fa1d.png";